const NotFound = () => {
    return (
        <div className="bg-primary min-h-screen flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <p>The page you are looking for was not found</p>
        </div>
    )

}

export default NotFound;